import { render, staticRenderFns } from "./ProtocolloAnteprima.vue?vue&type=template&id=2b14ab86&"
import script from "./ProtocolloAnteprima.vue?vue&type=script&lang=js&"
export * from "./ProtocolloAnteprima.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolloAnteprima.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/ProtocolloAnteprima.vue
// module id = 880
// module chunks = 0